import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useAuth } from '../context/AuthContext';
import LogoSG from '../../assets/images/logos/SG 05.png';
//import LogoSG from '../../assets/images/logos/synergyoscuro.png';
import TradingViewTicker from '../../services/TradingViewTicker';
import { API_ENDPOINTS } from '../../services/Endpoints';
const API_BASE = import.meta.env.VITE_APP_API_URL;


const HeaderPortal = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { logout } = useAuth?.() || {};
    const { t } = useTranslation('header');
    // Estado de autenticación
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);

    const activeColorClass = 'text-primary';  // Cambiar al color de tu paleta
    const borderColor = 'var(--bs-primary)'; // Color del subrayado

    const handleTabClick = (path) => {
        navigate(path); // Navega a la ruta correspondiente
    };

    const handleLogout = () => {
        // Abrir modal de confirmación de cierre de sesión
        setModalOpen(true);
    };
    const confirmLogout = async () => {


        const token = localStorage.getItem('token');

        try {
            if (token) {
                const url = `${API_BASE}${API_ENDPOINTS.POSTCERRARSESION()}`;
                const resp = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                    //body: JSON.stringify({}),
                });

                const result = await resp.json();

                if (resp.ok && result?.succeeded && result?.data === true) {
                    console.log('Cierre de sesión en backend exitoso:', result);
                } else {
                    console.warn('Logout backend respondió con error o estado inesperado:', result);
                }
            }
        } catch (err) {
            console.error('Error en cierre de sesión:', err);
            // Si falla, igual seguimos con el logout local
        }

        // 1) Avisar al AuthContext (si expone logout)
        if (typeof logout === 'function') {
            logout();
        }

        // 2) Borrar cualquier rastro en localStorage
        localStorage.removeItem('token');

        // 3) Disparar evento 'storage' para que otros listeners reaccionen (como tu propio useEffect)
        window.dispatchEvent(new StorageEvent('storage', { key: 'token', newValue: null }));

        // 4) Actualizar estado local y cerrar modal
        setIsAuthenticated(false);
        setModalOpen(false);

        // 5) Redirigir al login
        navigate('/auth/login', { replace: true });
    };
    const cancelLogout = () => {
        // Solo cerrar el modal sin hacer nada
        setModalOpen(false);
    };
    // util: token válido?
    const getValidTokenFromStorage = () => {
        const t = localStorage.getItem('token');
        if (!t) return null;
        try {
            const [, payloadB64] = t.split('.');
            const payload = JSON.parse(atob(payloadB64));
            const expMs = (payload?.exp ?? 0) * 1000;
            if (Date.now() < expMs) return t;   // válido
        } catch { }
        return null; // inválido/expirado/corrupto
    };

    useEffect(() => {
        const onRouteOrStorageChange = () => {
            // si estás en /auth/*, muestras menú sin sesión siempre
            if (location.pathname.startsWith('/auth/')) {
                setIsAuthenticated(false);
                return;
            }
            // si no estás en /auth/*, decide por token válido
            setIsAuthenticated(!!getValidTokenFromStorage());
        };

        onRouteOrStorageChange();                 // inicial
        window.addEventListener('storage', onRouteOrStorageChange); // otras pestañas
        return () => window.removeEventListener('storage', onRouteOrStorageChange);
    }, [location.pathname]);

    // cuando recibas 401 en cualquier fetch centralizado:
    // localStorage.removeItem('token'); window.dispatchEvent(new StorageEvent('storage', {key:'token'}));
    // Helpers para activo
    const isPath = (p) => location.pathname === p;
    const isIn = (...paths) => paths.some((p) => location.pathname.startsWith(p));
    const tabStyle = (active) => ({
        cursor: 'pointer',
        paddingTop: '45px',
        paddingBottom: '15px',
        borderBottom: `6px solid ${active ? 'var(--bs-primary)' : 'transparent'}`,
        fontWeight: active ? '600' : '400',
        transition: 'border-bottom 0.4s',
    });


    return (
        <>
            <div style={{ width: '100%', height: '30px', display: 'flex', alignItems: 'center', paddingTop: '15px' }}>
                <TradingViewTicker />
            </div>

            {/* <div
                className="bg-light border-bottom px-4"
                style={{
                    height: '80px',
                    display: 'flex',
                    alignItems: 'center',
                    position: 'relative',
                    zIndex: 1030,
                }}
            > */}
            <div
                className="bg-light border-bottom px-2 px-md-4"
                style={{
                    height: '80px',
                    display: 'flex',
                    alignItems: 'center',
                    position: 'relative',
                    zIndex: 1030,
                }}
            >

                <Row className="align-items-center w-100">
                    {/* Logo a la izquierda (solo en md en adelante) */}
                    <Col
                        xs="12"
                        md="6"
                        className="d-none d-md-flex align-items-center px-2 px-md-4"
                    >
                        <img
                            src={LogoSG}
                            alt="Logo SG"
                            height={90}
                            style={{ paddingBottom: '10px', paddingTop: '10px' }}
                        />
                    </Col>

                    {/* Pestañas a la derecha (en móviles ocupa todo el ancho) */}
                    <Col
                        xs="12"
                        md="6"
                        className="d-flex justify-content-end align-items-center gap-4"
                    >
                        {!isAuthenticated ? (
                            <>
                                {/* --- SIN SESIÓN --- */}
                                <div
                                    onClick={() => handleTabClick('/auth/login')}
                                    className={location.pathname === '/auth/login' ? activeColorClass : 'text-muted'}
                                    style={{
                                        cursor: 'pointer',
                                        paddingTop: '45px',
                                        paddingBottom: '15px',
                                        borderBottom: `6px solid ${location.pathname === '/auth/login' ? borderColor : 'transparent'
                                            }`,
                                        fontWeight: location.pathname === '/auth/login' ? '600' : '400',
                                        transition: 'border-bottom 0.4s',
                                    }}
                                >
                                    {t('login')}
                                </div>

                                <div
                                    onClick={() => handleTabClick('/auth/activarcuenta')}
                                    className={location.pathname === '/auth/activarcuenta' ? activeColorClass : 'text-muted'}
                                    style={{
                                        cursor: 'pointer',
                                        paddingTop: '45px',
                                        paddingBottom: '15px',
                                        borderBottom: `6px solid ${location.pathname === '/auth/activarcuenta' ? borderColor : 'transparent'
                                            }`,
                                        fontWeight: location.pathname === '/auth/activarcuenta' ? '600' : '400',
                                        transition: 'border-bottom 0.4s',
                                    }}
                                >
                                    {t('activateAccount')}
                                </div>

                                {/* <div
                                    onClick={() => handleTabClick('/auth/simulador')}
                                    className={isPath('/auth/simulador') ? 'text-primary' : 'text-muted'}
                                    style={tabStyle(isPath('/auth/simulador'))}
                                >
                                    {t('simulator')}
                                </div> */}
                            </>
                        ) : (
                            <>
                                {/* --- CON SESIÓN --- */}
                                <div
                                    onClick={() => handleTabClick('/app/starter')}
                                    className={isIn('/app/starter') ? 'text-primary' : 'text-muted'}
                                    style={tabStyle(isIn('/app/starter'))}
                                >
                                    {t('home')}
                                </div>

                                {/* <div
                                    onClick={() => handleTabClick('/app/simulador')}
                                    className={isPath('/app/simulador') ? 'text-primary' : 'text-muted'}
                                    style={tabStyle(isPath('/app/simulador'))}
                                >
                                    {t('simulator')}
                                </div> */}

                                <div
                                    onClick={() => handleTabClick('/app/empresa')}
                                    className={isPath('/app/empresa') ? 'text-primary' : 'text-muted'}
                                    style={tabStyle(isPath('/app/empresa'))}
                                >
                                    {t('company')}
                                </div>

                                {/* CERRAR SESIÓN */}
                                <div
                                    onClick={handleLogout}
                                    style={{
                                        color: 'var(--bs-primary)',
                                        cursor: 'pointer',
                                        paddingTop: '45px',
                                        paddingBottom: '15px',
                                        borderBottom: '6px solid transparent',
                                        fontWeight: '600',
                                        transition: 'opacity 0.2s',
                                    }}
                                >
                                    {t('logout')}
                                </div>
                            </>
                        )}
                    </Col>
                </Row>


                {/* Modal de Confirmación de Cierre de Sesión */}
                <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)}>
                    <ModalHeader toggle={() => setModalOpen(!modalOpen)}> {t('logoutModalTitle')}</ModalHeader>
                    <ModalBody>
                        {t('logoutModalBody')}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={confirmLogout}>
                            {t('logoutModalConfirm')}
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        </>
    );
};

export default HeaderPortal;
